import { styled } from '@mui/material';

export const Textarea = styled('textarea')`
  position: fixed;
  top: 40%;
  left: 0;
  right: 0;
  bottom: 35%;
`;
